import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "src/api/product.api";
import { GetProductDto } from "src/services/generated-api";

export const productsQueryKey = ["products"] as const;

export function useProducts() {
  return useQuery<GetProductDto[]>({
    queryKey: productsQueryKey,
    queryFn: fetchProducts,
    staleTime: 5 * 60 * 1000,
  });
}
